
webpack.register(
    'modules/live-multiline-player/live-multiline-player',
    function() {
        return import('modules/live-multiline-player/live-multiline-player');
    },
    true
);